import { LOADER_HIDE, LOADER_SHOW } from "../Types/LoaderTypes";

export const LoaderShow = () => ({
  type: LOADER_SHOW,
});

export const LoaderHide = () => ({
  type: LOADER_HIDE,
});
